import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";

export function AuthLayout({ children }: { children: React.ReactNode }) {
    return (
        <div>
            <Header />
            <div className="py-12 w-full flex items-center justify-center bg-[#FFF9F2] p-4 font-sans text-[#4A4A4A]">
                <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Great+Vibes&display=swap');
                .font-script {
                    font-family: 'Great Vibes', cursive;
                    }
                    `}</style>
                <div className="w-full max-w-[450px] mx-auto flex flex-col items-center">
                    {children}
                </div>
            </div>
            <Footer />
        </div>
    );
}

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    error?: string;
}

export const AuthInput = React.forwardRef<HTMLInputElement, InputProps>(({ error, className, ...props }, ref) => {
    return (
        <div className="w-full mb-4">
            <input
                ref={ref}
                className={`w-full bg-white rounded-lg px-4 py-3.5 text-gray-700 placeholder-gray-400 border-none outline-none focus:ring-1 focus:ring-gray-200 shadow-sm ${className}`}
                {...props}
            />
            {error && <p className="text-red-500 text-xs mt-1 ml-1">{error}</p>}
        </div>
    );
});
AuthInput.displayName = "AuthInput";

export const AuthPasswordInput = React.forwardRef<HTMLInputElement, InputProps>(({ error, className, ...props }, ref) => {
    const [show, setShow] = useState(false);
    return (
        <div className="w-full mb-4">
            <div className="relative">
                <input
                    ref={ref}
                    type={show ? "text" : "password"}
                    className={`w-full bg-white rounded-lg px-4 py-3.5 text-gray-700 placeholder-gray-400 border-none outline-none focus:ring-1 focus:ring-gray-200 shadow-sm pr-10 ${className}`}
                    {...props}
                />
                <button
                    type="button"
                    onClick={() => setShow(!show)}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-300 hover:text-gray-500"
                >
                    {show ? <FaEyeSlash size={20} /> : <FaEye size={20} />}
                </button>
            </div>
            {error && <p className="text-red-500 text-xs mt-1 ml-1">{error}</p>}
        </div>
    );
});
AuthPasswordInput.displayName = "AuthPasswordInput";


export const AuthButton = ({ children, onClick, disabled, type = "submit" }: { children: React.ReactNode, onClick?: () => void, disabled?: boolean, type?: "button" | "submit" | "reset" }) => (
    <button
        type={type}
        disabled={disabled}
        onClick={onClick}
        className="w-full bg-[#E86C31] hover:bg-[#d55b25] text-white font-medium text-lg rounded-lg py-3 mt-4 transition-colors disabled:opacity-50"
    >
        {children}
    </button>
);
